import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M5.37556 0H16.7998V14.3809L14.7358 21.811C14.4958 23.3929 12.8517 24.4475 11.1837 23.8124C10.1877 23.4289 9.59966 22.3982 9.59966 21.3316V15.5793C9.59966 14.9202 9.05964 14.3809 8.39963 14.3809H3.2875C1.17545 14.3809 -0.384586 12.4155 0.0834256 10.3663L2.17147 2.54062C2.51948 1.05459 3.83952 0 5.37556 0ZM21.5999 0H19.1999V14.3809H21.5999C22.92 14.3809 24 13.3023 24 11.9841V2.39682C24 1.07857 22.932 0 21.5999 0Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
